;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();type Video = {
  source: 'youtube' | 'vimeo';
  id: string;
};

export default function VideoPlayer({ content, ...props }) {
  if (!content) return null;
  const video: Video | undefined = (() => {
    if (typeof content === 'string') {
      // Using legacy format: the content refers to a YouTube ID
      return { source: 'youtube', id: content };
    } else if (typeof content === 'object') {
      // Using new format: the content is a video object
      return { source: content.source, id: content.videoId };
    }
  })();

  const src =
    video?.source === 'youtube' ? `https://www.youtube.com/embed/${video.id}` : `https://player.vimeo.com/video/${video?.id}`;

  return (
    <div className={`youtubeContainer ${props.className}`}>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          title={`synergie ${video?.source} video`}
          className="embed-responsive-item"
          src={src}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; fullscreen;"
          allowFullScreen
        />
      </div>
    </div>
  );
}
